import { useParams } from 'react-router';
import { useFetchMandatesInvitationData } from 'receivable-invoices-js/react/api/queries/fetch-mandates-invitation-data';

export function useRouteQuery() {
  const { id } = useParams<{ id: string }>();

  const { data, isLoading, isError, refetch } = useFetchMandatesInvitationData(
    { invitationLinkId: id ?? '' },
    { enabled: Boolean(id) }
  );

  return {
    data,
    isError,
    isLoading,
    refetch,
  };
}
